import { Tooltip as MuiTooltip } from '@mui/material';

/**
 * MUI Tooltip wrapper component
 * @deprecated Use the Trellis Tooltip component instead: https://main--6710219e5989b079dbcc9421.chromatic.com/?path=/docs/components-tooltip--docs
 */
export default function Tooltip({ children, isExpanded = false, label }) {
	return (
		<MuiTooltip
			arrow
			title={label}
			placement="right"
			disableHoverListener={isExpanded}
			PopperProps={{
				modifiers: [
					{
						name: 'offset',
						options: {
							offset: [0, 12]
						}
					}
				]
			}}>
			{children}
		</MuiTooltip>
	);
}
